import { select, call, takeLatest, put, takeEvery } from 'redux-saga/effects';

import { CaseActions } from '../constants';
import { CaseApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import {
    DeleteCaseAction,
    GetCaseAction,
    GetCasesAction,
    PersistCaseAction,
    CreateFilesCaseAction,
    GetFilesAction,
    DeleteFileCaseAction,
    UpdateCaseAction,
    GetCasesAnotherAction,
    CaseNumbersAction,
    CaseNumbersStudentAction,
    GetStatementsDocsAction, GetCasesSmallAction,
} from '../actions/case-actions';
import sortingService from '../../services/sorting';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
    successType,
} from '../../services/api-handlers/api-resolver';
import { SubmissionError } from 'redux-form';
import { makeFormErrors } from '../../components/redux-form/utils/make-form-errors';
import { convertValuesToFormData } from '../../components/redux-form/utils/values-to-form-data';
import { push } from 'connected-react-router';
import Router from '../../navigation/router';
import routes from '../../navigation/routes';
import { groupCase } from '../../helpers/case/case';
import { toast } from 'react-toastify';
import { CreateInvoiceAction } from '../actions/invoice-actions';

function* handleFetchCases(action: GetCasesAction) {
    const oldData = yield select((state: StoreState) => state.cases.data);
    const { sorting, page, itemsPerPage } = action.payload;
    let filtersTo: any = { ...action.payload.filters };

    if (filtersTo?.createdAt) {
        filtersTo = {
            ...filtersTo,
            ...filtersTo?.createdAt,
        };
        delete filtersTo.createdAt;
    }

    if (filtersTo?.status) {
        filtersTo.statusFilter = filtersTo.status;
        delete filtersTo.status;
    }
    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        CaseApi.getCases({
            ...filtersTo,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchCasesSmall(action: GetCasesSmallAction) {
    const oldData = yield select((state: StoreState) => state.cases.data);
    const { sorting, page, itemsPerPage } = action.payload;
    let filtersTo: any = { ...action.payload.filters };

    if (filtersTo?.createdAt) {
        filtersTo = {
            ...filtersTo,
            ...filtersTo?.createdAt,
        };
        delete filtersTo.createdAt;
    }

    if (filtersTo?.status) {
        filtersTo.statusFilter = filtersTo.status;
        delete filtersTo.status;
    }
    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        CaseApi.getCasesSmall({
            ...filtersTo,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchCheckCases1(action: any) {

    let isDouble: any = false;

    const { filters, sorting, page, itemsPerPage } = action.payload;
    const filterProps: any = { ...filters };
    //const { names } = filters;

    //for (let i = 0; i < names.length; i++) {
    const result: any = yield CaseApi.getCases({
        ...filterProps,
        order: sortingService.makeOrder(sorting),
        page,
        itemsPerPage,
        pagination: itemsPerPage === -1 ? 0 : 1,
    });
    if (result.data.length) {
        isDouble = true;
    }
    //}

    isDouble = !isDouble ? 'no' : isDouble;

    const actionResult = {
        payload: { isDouble },
        type: successType(CaseActions.FETCH_CHECK_CASES),
    };
    yield put(actionResult);
}

function* handleFetchStatementDocs(action: GetStatementsDocsAction) {
    const oldData = yield select((state: StoreState) => state.cases.statementDocs);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        CaseApi.getStatementDocs({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleCaseNumber(action: CaseNumbersAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, async () => CaseApi.getCaseNumbers(id));
}

function* handleCaseNumberStudent(action: CaseNumbersStudentAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, async () => CaseApi.getCaseNumbersStudent(id));
}

function* handleFetchCasesAnother(action: GetCasesAnotherAction) {
    const oldData = yield select((state: StoreState) => state.cases.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        CaseApi.getCases({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchCase(action: GetCaseAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => CaseApi.getCase(id));
}
function* handleCreateStatement(action: CreateInvoiceAction) {
    const {
        payload: { data, onSuccess, onError },
    } = action;
    yield resolveApiCall(
        action,
        () => CaseApi.createStatementCase(data),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}
function* handleDeleteCase(action: DeleteCaseAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => CaseApi.deleteCase(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handleUpdateCase(action: UpdateCaseAction) {
    const { payload } = action;
    const { data, onSuccess, onError } = payload;
    const id: any = data.id;

    yield resolveApiCall(
        action,
        () => CaseApi.updateCase(id, data),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistCase(action: PersistCaseAction) {
    const { payload } = action;
    const {
        data: { id },
        files,
        callbacks,
    } = payload;
    const groupData = groupCase(payload.data);

    yield resolveApiCall(
        action,
        () => (id ? CaseApi.updateCase(id, groupData) : CaseApi.createCase(groupData)),
        function* (data: ResolverApiSuccess) {
            const actionFiles: CreateFilesCaseAction = {
                type: CaseActions.CREATE_FILES_CASE,
                payload: {
                    id: data.payload.id,
                    files,
                    onSuccess: () => false,
                    onError: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            };
            yield call(handleCreateFilesCase, actionFiles);
            yield call(callbacks.resolve);
            if (!id) {
                yield put(push(Router.generate(routes.CASES_LIST)));
            } else {
                yield put(push(Router.generate(routes.CASE_CALENDAR, { id })));
            }
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                yield call(
                    callbacks.reject,
                    result.error instanceof SubmissionError
                        ? result.error
                        : new SubmissionError({
                              _error: result.error.message ?? 'Incorrect response',
                              ...makeFormErrors(result.error.response?.data),
                          }),
                );
            }
            handleError(result);
        },
    );
}

function* handleGetFilesCase(action: GetFilesAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => CaseApi.getFilesCase(id));
}

function* handleCreateFilesCase(action: CreateFilesCaseAction) {
    const {
        payload: { id, files, onSuccess, onError },
    } = action;

    for (let i = 0; i < files.length; i++) {
        if (files[i]?.id || files[i]?.attach || !files[i].type) {
            continue;
        }
        const formData = convertValuesToFormData({ occasion: id, attachFile: files[i] }, '');
        yield resolveApiCall(
            action,
            () => CaseApi.createFilesCase(formData),
            function (data: ResolverApiSuccess) {
                if (onSuccess) {
                    onSuccess();
                }
            },
            function (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    if (onError) {
                        onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                    }
                }
            },
        );
    }
}

function* handleDeleteFileCase(action: DeleteFileCaseAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => CaseApi.deleteFileCase(id),
        function (data) {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(CaseActions.FETCH_CASES, handleFetchCases);
    yield takeLatest(CaseActions.FETCH_CASES_SIMPLY, handleFetchCasesSmall);
    yield takeEvery(CaseActions.FETCH_CHECK_CASES, handleFetchCheckCases1);
    yield takeLatest(CaseActions.FETCH_CASES_ANOTHER, handleFetchCasesAnother);
    yield takeLatest(CaseActions.FETCH_CASE, handleFetchCase);
    yield takeLatest(CaseActions.CREATE_STATEMENT, handleCreateStatement);
    yield takeLatest(CaseActions.FETCH_STATEMENT_DOCS, handleFetchStatementDocs);
    yield takeLatest(CaseActions.DELETE_CASE, handleDeleteCase);
    yield takeLatest(CaseActions.PERSIST_CASE, handlePersistCase);
    yield takeLatest(CaseActions.UPDATE_CASE, handleUpdateCase);
    yield takeLatest(CaseActions.DELETE_FILE_CASE, handleDeleteFileCase);
    yield takeLatest(CaseActions.CREATE_FILES_CASE, handleCreateFilesCase);
    yield takeLatest(CaseActions.FETCH_FILES_CASE, handleGetFilesCase);
    yield takeLatest(CaseActions.CASE_NUMBERS, handleCaseNumber);
    yield takeLatest(CaseActions.CASE_NUMBERS_STUDENT, handleCaseNumberStudent);
}
